import React from 'react';
import { numberTileClass } from './numberTile';
interface RatingCueProps {
  value: number | null;
  onChange: (value: number) => void;
  lowLabel: string;
  highLabel: string;
}
const SCALE = [1, 2, 3, 4, 5];
export function RatingCue({
  value,
  onChange,
  lowLabel,
  highLabel
}: RatingCueProps) {
  return <div data-id="element-211" data-mp="2yb180ojjljdx">
      <div className="flex gap-2" role="group" aria-label="Rate from 1 to 5" data-id="element-212" data-mp="2yccaml194l3g">
        {SCALE.map(n => {
        const isMine = value === n;
        return <button key={n} type="button" onClick={() => onChange(n)} aria-pressed={isMine} className={`${numberTileClass(isMine, 'h-14 flex-1 text-[18px]')} ${isMine ? '' : 'hover:border-blue'}`} data-id="element-213" data-mp="26kembeu9jrxx">
              {n}
            </button>;
      })}
      </div>
      <div className="mt-2 flex items-start justify-between gap-4" data-id="element-214" data-mp="3w0w28mi67dzq">
        <span className="max-w-[45%] text-[10.5px] leading-snug text-mut" data-id="element-215" data-mp="3qzgmn9yrhzoq">1 — {lowLabel}</span>
        <span className="max-w-[45%] text-right text-[10.5px] leading-snug text-mut" data-id="element-216" data-mp="2q0fpqmzf1kd2">
          5 — {highLabel}
        </span>
      </div>
    </div>;
}